import { render, staticRenderFns } from "./OctPagination.vue?vue&type=template&id=48f949b9&scoped=true&"
import script from "./OctPagination.vue?vue&type=script&lang=js&"
export * from "./OctPagination.vue?vue&type=script&lang=js&"
import style0 from "./OctPagination.vue?vue&type=style&index=0&id=48f949b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f949b9",
  null
  
)

export default component.exports